import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { BackgroundProgress } from 'core/http/project/background/background-task.service';
import {
  ChainNoticeOutput,
  CourierChainNoticeTriggerInput,
  NoticeTriggerOutput,
  ScheduledNoticeOutput,
  ScheduledNoticeTriggerInput,
  TelegramChatOutput,
} from 'core/http/project/notice/notice.interfaces';
import { Observable } from 'rxjs';
import { Uuid } from 'shared/common/types';

@Injectable()
export class NoticeService {
  constructor(private http: HttpClient) {}

  getTriggers(): Observable<NoticeTriggerOutput[]> {
    return this.http.get<NoticeTriggerOutput[]>(apiUrl('/project/notice-triggers'));
  }

  createCourierChainTrigger(input: CourierChainNoticeTriggerInput): Observable<ChainNoticeOutput> {
    return this.http.post<ChainNoticeOutput>(apiUrl('/project/notice-triggers/courier-chain'), input);
  }

  updateCourierChainTrigger(triggerId: Uuid, input: CourierChainNoticeTriggerInput): Observable<ChainNoticeOutput> {
    return this.http.put<ChainNoticeOutput>(apiUrl(`/project/notice-triggers/${triggerId}/courier-chain`), input);
  }

  createScheduledTrigger(input: ScheduledNoticeTriggerInput): Observable<ScheduledNoticeOutput> {
    return this.http.post<ScheduledNoticeOutput>(apiUrl('/project/notice-triggers/scheduled'), input);
  }

  updateScheduledTrigger(triggerId: Uuid, input: ScheduledNoticeTriggerInput): Observable<ScheduledNoticeOutput> {
    return this.http.put<ScheduledNoticeOutput>(apiUrl(`/project/notice-triggers/${triggerId}/scheduled`), input);
  }

  removeNotice(id: Uuid): Observable<object> {
    return this.http.delete<object>(apiUrl(`/project/notice-triggers/${id}`));
  }

  resendNotice(unloadingId: Uuid, chainNoticeId: Uuid, destinations: string[]): Observable<BackgroundProgress> {
    return this.http.post<BackgroundProgress>(apiUrl(`/project/unloading/${unloadingId}/chain-notice/${chainNoticeId}`), { destinations });
  }

  getTelegramChats(): Observable<TelegramChatOutput[]> {
    return this.http.get<TelegramChatOutput[]>(apiUrl('/project/courier-chains/telegram-chats'));
  }
}
